import { Platform } from "react-native";
import config from "../../config";

export const toPathSegment = (domain?: string) => (domain || "").replaceAll(".", "-");
export const memberPrefix = (path: string) => [toPathSegment(config.webDomain), "member", path].join("/");
export const dcPrefix = (path: string) => memberPrefix(`deferred-comp/${path}`);

const PUBLIC_PATHS = ["/member/dues-proxy-payment/"];
export const isPublicPath = () =>
  Platform.OS === "web" && PUBLIC_PATHS.some((path) => window.location.pathname.startsWith(path));
